import React, { Component } from 'react';
import { Form, Input, message, Modal, Row, Select } from 'antd';
import { connect } from 'react-redux';

import { querySaveInvoice, queryXxOrg } from '@api/xxcrm/invoice';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyList: [],
    };
  }

  componentDidMount() {
    this.loadCompanyList();
  }

  setCompany = (value, option) => {
    this.companyName = option.props.children;
  };

  /**
   * 获取公司列表
   */
  loadCompanyList = () => {
    queryXxOrg().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          companyList: res.data,
        });
      }
    });
  };

  submit = () => {
    const data = this.props.form.getFieldsValue();
    this.props.form.validateFields(err => {
      if (!err) {
        querySaveInvoice(data).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.props.loadDate();
            this.props.cancel();
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { companyList } = this.state;
    return (
      <Modal
        title="添加发票"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="发票类型" {...formItemLayout}>
              {getFieldDecorator('invoiceType', {
                rules: [{ required: true, message: '发票类型不能为空！' }],
              })(
                <Select>
                  <Option key="1">国税网络在线发票</Option>
                  <Option key="2">增值税专用发票</Option>
                  <Option key="3">增值税普通发票</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="开票公司" {...formItemLayout}>
              {getFieldDecorator('company', {
                rules: [{ required: true, message: '开票公司不能为空！' }],
              })(
                <Select onSelect={this.setCompany}>
                  {companyList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="发票号前缀" {...formItemLayout}>
              {getFieldDecorator('noPrefix', {
                rules: [{ required: true, message: '发票号前缀不能为空！' }],
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="数字位数" {...formItemLayout}>
              {getFieldDecorator('digits', {
                rules: [{ required: true, message: '数字位数不能为空' }],
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="起始编号" {...formItemLayout}>
              {getFieldDecorator('beginNo', {
                rules: [{ required: true, message: '起始编号不能为空！' }],
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="生成个数" {...formItemLayout}>
              {getFieldDecorator('num', {
                rules: [{ required: true, message: '生成个数不能为空！' }],
              })(<Input />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/invoice/ModalAdd.js